import { defineComponent as h, computed as a, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as d, createCommentVNode as v, normalizeStyle as n, createStaticVNode as f } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "11553f0a-763c-45fb-a86d-47582f5a398e" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#11553f0a-763c-45fb-a86d-47582f5a398e)" }, k = { key: 0 }, u = /* @__PURE__ */ f('<path fill="#496e2d" d="M0 352h512v160H0z"></path><path fill="#d80027" d="M0 160h512v192H0z"></path><path fill="#0052b4" d="M0 0h512v160H0z"></path><path fill="#ffda44" d="M398 256a168 168 0 1 1-336 0 168 168 0 0 1 336 0z"></path><path fill="#333" d="M230 80a176 176 0 1 0 0 352 176 176 0 0 0 0-352zm-8 16v34c-8 4-14 8-15 16l-1 16 6-3 10-4v8a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8h-20v16h20v8a24 24 0 0 0-16 22 24 24 0 0 0 16 23v7h-20v17h20v7a24 24 0 0 0-16 23 24 24 0 0 0 16 22v8c-10 0-18 3-23 7-7 5-22 20-30 28a160 160 0 0 1 53-308zm16 0a160 160 0 0 1 51 309l-30-29c-5-4-12-6-21-7v-8a24 24 0 0 0 16-22 24 24 0 0 0-16-23v-7h21v-16h-21v-8a24 24 0 0 0 16-23 24 24 0 0 0-16-22v-8h21v-16h-21v-7a24 24 0 0 0 16-23 24 24 0 0 0-16-23v-20c6-5 11-13 17-23 4-8 2-11 2-11l-2 3-17 11V96z"></path>', 5), g = { fill: "none" }, z = ["r"], N = /* @__PURE__ */ h({
  __name: "nc",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, o = a(() => 512 + 2 * e.strokeWidth), l = a(() => -e.strokeWidth), r = a(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${l.value} ${l.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (s(), c("title", k, d(e.flagName), 1)) : v("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, p));
  }
});
export {
  N as default
};
//# sourceMappingURL=nc-e7089660.js.map
